module.exports = {
  src: __webpack_public_path__ + "assets/images/close-icon.562d6f7d6ced3472.svg",
  width: 15,
  height: 15,
  toString: function() { return __webpack_public_path__ + "assets/images/close-icon.562d6f7d6ced3472.svg"; }
};